import { cn } from '@savvy-kit/lib/utils';
import { Home } from 'lucide-react';

const SIZE_CLASSES = {
  xs: 'size-4',
  sm: 'size-6',
  lg: 'size-10',
} as const;

const ICON_SIZE_CLASSES = {
  xs: 'size-2.5',
  sm: 'size-3.5',
  lg: 'size-5',
} as const;

type Props = {
  readonly size?: keyof typeof SIZE_CLASSES;
};

// Households have no photo, so a plain centered icon stands in for the shared
// Avatar's customFallback slot — that slot doesn't center non-initial content.
export function HouseholdAvatar({ size = 'sm' }: Props) {
  return (
    <div className={cn('flex shrink-0 items-center justify-center rounded-full bg-primary/10', SIZE_CLASSES[size])}>
      <Home className={cn('text-dark', ICON_SIZE_CLASSES[size])} />
    </div>
  );
}
